<template>
  <div class="left">
    <div class="list_1" @click="getBooks('','','1','','','本土著述','1')">
      <span class="text" data-name="local">本土著述</span>
      <span v-if="current_title_1!==1" class="more_icon" @click="changeTitle1(1)">
        <img height="" width="" src="../../assets/public/ancientBooks/more_icon@2x.png" alt />
      </span>
      <span v-else class="close_icon" @click="closeTitle1()">
        <img height="" width="" src="../../assets/public/ancientBooks/esc_cion@2x.png" alt />
      </span>
    </div>
    <ul :class="[current_title_1==1?'show':'','content_1','animate']">
      <li v-for="(item,index) in localLists" :key="index">
        <span v-if="folderIconList[index]=='folder'" @click="doTask(index)" class="icon">
          <img
            class="right_icon"
            v-if="!scope[index]"
            height="" width=""
            src="../../assets/public/ancientBooks/right_icon@2x.png"
            alt
          />
          <img class="down_icon" height="" width="" v-else src="../../assets/public/ancientBooks/down_icon@2x.png" alt />
        </span>
        <div class="list_2" @click="getBooks('',item.category_id,'1','',item.name,'本土著述','2')">
          <span>{{item.name}}</span>
        </div>
        <div :class="[scope[index]?'active':'','content_2','animate']">
          <ul v-for="(subItem,index) in item.subItems" :key="index">
            <li
              :class="[subItem.category_id == current_category_id?'active':'','list_3']"
              @click="getBooks(subItem.category_id,item.category_id,'1',subItem.name,item.name,'本土著述','3')"
            >{{subItem.name}}</li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="list_1 list_1_b" @click="getBooks('','','2','','','域外著述','1')">
      <span class="text" data-name="outside">域外著述</span>
      <span v-if="current_title_1!==2" class="more_icon" @click="changeTitle1(2)">
        <img height="" width="" src="../../assets/public/ancientBooks/more_icon@2x.png" alt />
      </span>
      <span v-else class="close_icon" @click="closeTitle1()">
        <img height="" width="" src="../../assets/public/ancientBooks/esc_cion@2x.png" alt />
      </span>
    </div>
    <ul :class="[current_title_1==2?'show':'','content_1','animate']">
      <li v-for="(item,index) in outLists" :key="index">
        <span v-if="folderIconList_[index]=='folder'" @click="doTask_(index)" class="icon">
          <img
            class="right_icon"
            v-if="!scope_[index]"
            src="../../assets/public/ancientBooks/right_icon@2x.png"
            height="" width=""
            alt
          />
          <img class="down_icon" width="" height="" v-else src="../../assets/public/ancientBooks/down_icon@2x.png" alt />
        </span>
        <div class="list_2" @click="getBooks('',item.category_id,'2','',item.name,'域外著述','2')">
          <span>{{item.name}}</span>
        </div>
        <div :class="[scope_[index]?'active':'','content_2','animate']">
          <ul v-for="(subItem,index) in item.subItems" :key="index">
            <li
              :class="[subItem.category_id == current_category_id?'active':'','list_3']"
              @click="getBooks(subItem.category_id,item.category_id,'2',subItem.name,item.name,'域外著述','3')"
            >{{subItem.name}}</li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current_title_1: 1, //当前哪个一级标题打开 1打开本土，2打开域外
      current_title_2: 0, //当前哪个二级标题打开
      localLists: [],
      outLists: [],
      folderIconList: {},
      folderIconList_: {},
      scope: [],
      scope_: [],
      current_category_id: "",
      level: null
    };
  },
  props: ["parents"],
  created() {
    //type： 1：本土 2：域外
        this.getCategory(1);
        this.getCategory(2);
  },
  mounted() {},
  methods: {
    changeTitle1(i) {
      // event.stopPropagation();
      event.cancelBubble = true
      if (i == 1) {
        this.current_title_1 = 1;
      } else if (i == 2) {
        this.current_title_1 = 2;
      }
    },
    closeTitle1() {
      // event.stopPropagation();
      event.cancelBubble = true
      this.current_title_1 = 0; //不打开任何一级标题
      // console.log(this.current_title_1)
    },

    // 开启关闭本土的二级标题
    doTask(index) {
      // event.stopPropagation();
      event.cancelBubble = true
      let current = this.scope[index];
      for (let i = 0; i < this.scope.length; i++) {
        this.$set(this.scope, i, false);
      }
      this.$set(this.scope, index, !current);
      // console.log(this.scope)
    },
    // 开启关闭域外的二级标题
    doTask_(index) {
      // event.stopPropagation();
      event.cancelBubble = true
      let current = this.scope_[index];
      for (let i = 0; i < this.scope_.length; i++) {
        this.$set(this.scope_, i, false);
      }
      this.$set(this.scope_, index, !current);
    },
    // 获取分类字典列表
    getCategory(type) {
      let that = this;
      let datas = {
        type: type
      };
      that.$axios
        .get("book/menus", {
          params: datas
        })
        .then(res => {
          if (res.data.status_code == 200) {
            // console.log(res.data.data)
            if (type == 1) {
              that.localLists = res.data.data;
              // 初始化，如果有子分类，都添加折叠标志箭头<  并且将所有的折叠都关闭
              that.localLists.forEach((item, index) => {
                if (item.subItems && item.subItems.length) {
                  that.folderIconList[index] = "folder";
                  // that.scope[index] = false;
                  if(item.category_id == that.$store.state.pid){
                    that.scope[index] = true;
                  }else{
                    that.scope[index] = false;
                  }
                }
              });
            } else if (type == 2) {
              that.outLists = res.data.data;
              this.outLists.forEach((item, index) => {
                if (item.subItems && item.subItems.length) {
                  this.folderIconList_[index] = "folder";
                  // that.scope_[index] = false;
                  if(item.category_id == that.$store.state.pid){
                    that.scope[index] = true;
                  }else{
                    that.scope[index] = false;
                  }
                }
              });
            }
            // if(!this.$store.state.hashistory)
            // console.log(that.$store.state.category_id);
            if (
              !that.$store.state.category_id &&
              that.$store.state.category_id != ""&&!this.$store.state.hashistory
            ) {
              // 第一次打开此页面时 默认打开本土著述的所有书籍
              that.current_category_id = 1; //本土categry_id
              that.level = 1; //等级为 1级标题
              let datas = [];
              datas.push("", "", 1, "", "", "本土著述", 1);
              // that.getBooks("", "", 1, "", "", "本土著述", 1)
              // datas.push(
              // 	that.current_category_id,
              // 	'本土著述',
              // 	'',
              // 	'',
              // 	that.level
              // )
              // 向父组件ancientBooks 传递category_id值
              that.$emit("putCategoryId", datas);
            } else {
              // 如果是点击了某一个分类 从图书详情页跳转到图书列表页面，侧边栏需要重新定位
              // console.log('-=-=--=-==-=-')
              // console.log('category_name:'+that.$store.state.category_name)
              // console.log('p_category_name:'+that.$store.state.p_category_name)
              // console.log('pp_category_name:'+that.$store.state.pp_category_name)
              // console.log('-=-=-=-=-=-=')
              that.current_category_id = that.$store.state.category_id;
              let datas = [];
              datas.push(
                that.$store.state.category_id,
                that.$store.state.pid,
                that.$store.state.ppid,
                that.$store.state.category_name,
                that.$store.state.p_category_name,
                that.$store.state.pp_category_name,
                that.$store.state.level
              );
              //   console.log(datas);
              // datas.push(
              // 	that.$store.state.category_id,
              // 	that.$store.state.pid,
              // 	that.$store.state.ppid,
              // 	that.$store.state.category_name,
              // 	that.$store.state.p_category_name,
              // 	that.$store.state.pp_category_name,
              // 	that.$store.state.level
              // );
              // 向父组件ancientBooks传值
              that.$emit("putCategoryId", datas);
              if (that.$store.state.level == 1) {
                // 点击的是一级标题
                // 所有二级标题都关闭
                for (let i = 0; i < this.scope.length; i++) {
                  this.$set(this.scope, i, false);
                }
                for (let i = 0; i < this.scope_.length; i++) {
                  this.$set(this.scope_, i, false);
                }
                if (that.$store.state.category_id == 1) {
                  // 打开本土书籍的下拉
                  that.current_title_1 = 1;
                } else if (that.$store.state.category_id == 2) {
                  // 打开域外书籍的下拉
                  that.current_title_1 = 2;
                }
              } else if (that.$store.state.level == 2) {
                for (let i = 0; i < this.scope.length; i++) {
                  this.$set(this.scope, i, false);
                }
                for (let i = 0; i < this.scope_.length; i++) {
                  this.$set(this.scope_, i, false);
                }
                // 点击的是二级标题
                if (that.$store.state.pid == 1) {
                  // 本土打开
                  that.current_title_1 = 1;
                } else if (that.$store.state.pid == 2) {
                  // 域外打开
                  that.current_title_1 = 2;
                }
              } else if (that.$store.state.level == 3) {
                // 点击的是三级标题
                if (that.$store.state.ppid == 1) {
                  // 本土打开
                  that.current_title_1 = 1;
                  for (let i = 0; i < that.localLists.length; i++) {
                    if (
                      that.localLists[i].category_id == that.$store.state.id
                    ) {
                      this.$set(this.scope, i, true);
                      return;
                    }
                  }
                } else if (that.$store.state.ppid == 2) {
                  // 域外打开
                  that.current_title_1 = 2;
                  for (let i = 0; i < that.outLists.length; i++) {
                    if (that.outLists[i].category_id == that.$store.state.id) {
                      this.$set(this.scope_, i, true);
                      return;
                    }
                  }
                }
              }
            }
          } else {
            return false;
          }
          // console.log(that.localLists)
          // console.log(that.outLists)
        })
        .catch(function(err) {
          console.log(err)
        });
    },
    // 点击侧边栏分类
    // category_name 分类名称
    // p_category_name 父分类名称
    // pp_category_name 祖父分类名称
    // level  1：一级分类 2：二级分类 3：三级分类
    getBooks(
      id,
      pid,
      ppid,
      category_name,
      p_category_name,
      pp_category_name,
      level
    ) {
      this.current_category_id = id;
      //为了给图书详情传值，因为图书详情会从其他页面进入
      this.$store.commit("setCategoryId", id);
      this.$store.commit("setPid", pid);
      this.$store.commit("setPPid", ppid);
      this.$store.commit("setCategoryName", category_name);
      this.$store.commit("setPCategoryName", p_category_name);
      this.$store.commit("setPPCategoryName", pp_category_name);
      this.$store.commit("setLevel", level);
      this.$store.commit("sethashistory", true);
      // console.log("getBooks local id:" + id);
      //   console.log("pid:" + this.$store.state.pid);
      //   console.log("ppid:" + this.$store.state.ppid);
      //   console.log("category_name:" + this.$store.state.category_name);
      //   console.log("p_category_name:" + this.$store.state.p_category_name);
      //   console.log("pp_category_name:" + this.$store.state.pp_category_name);
      //   console.log("level:" + this.$store.state.level);
      //   console.log("------------------");
      // 向父组件ancientBooks 传递category_id值,category_name,父category_name，祖父category_name,等级level
      // this.ancientBooks(
      //   id,
      //   pid,
      //   ppid,
      //   category_name,
      //   p_category_name,
      //   pp_category_name,
      //   level
      // );
      let datas = [];
      datas.push(
        id,
        pid,
        ppid,
        category_name,
        p_category_name,
        pp_category_name,
        level
      );
      // console.log(datas)
      this.$emit("putCategoryId", datas);
      this.$router.push({ path: "/ancientBooks" });
    },
    ancientBooks(
      category_id,
      pid,
      ppid,
      category_name,
      p_category_name,
      pp_category_name,
      level
    ) {
      let that = this;
      if (level == 5) {
        // console.log("leval:1");
        // 点击的是一级标题
        // 所有二级标题都关闭
        for (let i = 0; i < this.scope.length; i++) {
          this.$set(this.scope, i, false);
        }
        for (let i = 0; i < this.scope_.length; i++) {
          this.$set(this.scope_, i, false);
        }
        if (category_id == 1) {
          // 打开本土书籍的下拉
          that.current_title_1 = 1;
        } else if (category_id == 2) {
          // 打开域外书籍的下拉
          that.current_title_1 = 2;
        }
      } else if (level == 6) {
        for (let i = 0; i < this.scope.length; i++) {
          this.$set(this.scope, i, false);
        }
        for (let i = 0; i < this.scope_.length; i++) {
          this.$set(this.scope_, i, false);
        }
        // 点击的是二级标题
        if (pid == 1) {
          // 本土打开
          that.current_title_1 = 1;
        } else if (pid == 2) {
          // 域外打开
          that.current_title_1 = 2;
        }
      } else if (level == 7) {
        // 点击的是三级标题
        if (ppid == 1) {
          // 本土打开
          that.current_title_1 = 1;
          // console.log(this.localLists)
          for (let i = 0; i < that.localLists.length; i++) {
            if (that.localLists[i].category_id == pid) {
              // console.log('pid = that.localLists['+i+'].category_id:'+that.localLists[i].category_id)
              this.$set(this.scope, i, true);
              return;
            }
          }
        } else if (ppid == 2) {
          // 域外打开
          that.current_title_1 = 2;
            // console.log(this.outLists)
          for (let i = 0; i < that.outLists.length; i++) {
            if (that.outLists[i].category_id == pid) {
              // console.log('pid:'+pid+' = that.outLists['+i+'].category_id:'+that.outLists[i].category_id)
              this.$set(this.scope_, i, true);
              return;
            }
          }
        }
      }
    }
  },
  watch: {
    // 监视bookDetail父组件传过来的category_id,pid,ppid
    parents(val, oldVal) {
      if (val) {
        // [1, 3, 9, "本土著述", "医经", "素问",3]
        // console.log(val[6])
        if (val[6] == 1||val[6] == 2||val[6] == 3) {
          this.getBooks(val[0], val[1], val[2], val[3], val[4], val[5], val[6]);
        }else if(val[6] == 5||val[6] == 6||val[6] == 7){
          this.ancientBooks(val[0], val[1], val[2], val[3], val[4], val[5], val[6]);
        }else if(val[6] == 4){
          this.getCategory(1);
          this.getCategory(2);
        }
        // if (val[6] == 1||val[6]==2||val[6]==3) {
        //   this.getBooks(val[0], val[1], val[2], val[3], val[4], val[5], val[6]);
        // }else if(val[6] == 5||val[6]==6||val[6]==7){
        //   this.ancientBooks(val[0], val[1], val[2], val[3], val[4], val[5], val[6])
        // }else{
        //   this.getCategory(1);
        //   this.getCategory(2);
        // }
      }
    }
  }
};
</script>

<style lang="scss" scoped="" type="text/css">
@import url("../../assets/style/app.scss");
// @import url('../../assets/style/ancientBooks.scss');
.box {
  background: url(../../assets/public/bg1.png);
}
.content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 80px;
  // display: flex;
}
.left {
  width: 240px;
  background: rgba(100, 60, 47, 0.8)
    url("../../assets/public/ancientBooks/left_bg@2x.png") no-repeat left top;
  background-size: 240px;
  padding: 40px 0;
  border-radius: 2px 2px 16px 16px;
  float: left;
  // .animate{
  // transition:top 0.5s;
  // }
  // 一级分类标题
  .list_1 {
    font-size: 18px;
    color: #ffd9c5;
    height: 44px;
    line-height: 44px;
    position: relative;
    background-size: 240px;
    position: relative;
    cursor: pointer;
    .text {
      // font-family:FZGB10;
      font-family: PingFangSC-Medium, sans-serif;
      font-weight: bold;
      display: inline-block;
      width: 240px;
      padding-left: 65px;
      box-sizing: border-box;
      background: url("../../assets/public/ancientBooks/local_icon.png")
        no-repeat 15px 9px;
      background-size: 24px;
      &:hover {
        background-color: rgba(242, 214, 179, 0.12);
        color: #fff;
      }
    }
    .more_icon,
    .close_icon {
      display: inline-block;
      width: 44px;
      height: 44px;
      position: absolute;
      right: 0;
      top: 0;
      img {
        width: 14px;
        position: absolute;
        left: 16px;
        top: 15px;
      }
      &:hover {
        background: rgba(242, 214, 179, 0.12);
      }
    }
  }
  .list_1_b {
    .text {
      background: url("../../assets/public/ancientBooks/outside_icon@2x.png")
        no-repeat 15px 9px;
      background-size: 24px;
    }
  }
  // 一级分类的子内容
  .content_1 {
    position: relative;
    // visibility: hidden;
    display: none;
    // opacity: 0;
    z-index: 1;
    height: 0;
    margin: 0;
    &.show {
      // visibility: visible;
      display: block;
      // opacity: 1;
      height: auto;
    }
    li {
      position: relative;
      .icon {
        display: inline-block;
        height: 44px;
        width: 50px;
        position: absolute;
        left: 0;
        top: 0;
        cursor: pointer;
        &:hover {
          background: rgba(242, 214, 179, 0.12);
        }
        .right_icon,
        .down_icon {
          width: 12px;
          position: absolute;
          left: 20px;
          top: 16px;
        }
      }
      .list_2 {
        height: 44px;
        line-height: 44px;
        color: #ffd9c5;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        padding-left: 68px;
        cursor: pointer;
        &:hover {
          background: rgba(242, 214, 179, 0.12);
          color: #fff;
        }
        span {
          display: inline-block;
          max-width: 140px;
          overflow: hidden;
        }
      }
      .content_2 {
        position: relative;
        visibility: hidden;
        opacity: 0;
        top: -20px;
        z-index: 1;
        height: 0;
        margin: 0;
        &.active {
          visibility: visible;
          opacity: 1;
          top: 0;
          height: auto;
        }
      }
    }
    // 二级分类标题
  }
  // 三级分类的标题
  .list_3 {
    height: 38px;
    line-height: 38px;
    font-size: 15px;
    color: #333;
    font-family: PingFangSC-Light;
    font-weight: 300;
    padding-left: 73px;
    color: #cead99;
    cursor: pointer;
    &:hover {
      background: rgba(242, 214, 179, 0.12);
      color: #fff;
    }
    &.active {
      background-color: #a85133;
      color: #fff;
    }
    // span{
    // 	display:inline-block;

    // 	overflow: hidden;
    // 	border:1px solid;
    // 	overflow: hidden;
    // 	text-overflow: ellipsis;
    // }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/public/side.vue